import {Deserializable} from "./deserializable.model";
import {InvoicePayment} from './invoicePayment.model';
import { WorkOrderPayment } from "./worOrderPayment.model";

export class Spending {


spending_id?: number;
spending_date?: string;
myob_account_code_id?: number;
myob_bank_account_code_id?: number;
from_brand_id?: number; // who the spendings will be appled to. (who the spending is from)
to_brand_id?: number; // who the spendings will be appled to. (who the spending is from)
spending_total?: number;
created_by?: number;
created_date?: string;
updated_by?: number;
updated_date?: string;

workOrderPayment?: WorkOrderPayment; // class


job_number?: string;
subject_number?: string;

work_order_id?: any;
work_orderUID?: string;
agent_id?: number;

is_bulk?: number;

// myob variables.
UID?;
DepositTo?;
AccountUID?;
CustomerUID?;
URI?;
myob_array?: any;
RowVersion?;
myob_id?;

brand_type_id?;
created_date_from?;
created_date_to?
access_level?
myob_sync_status?;
limit?;
work_order_status_id?;

  // ? what does this really do? (no encoding or deserialisation required...)
      // deserialize(input: any): Spending {
      //   Object.assign(this, input);
      //   this.workOrderPayment = new WorkOrderPayment().deserialize(input.workOrderPayment);
      //   return this;
      // }

  /*

payment_id
payment_date
myob_account_code_id
myob_bank_account_code_id
from_brand_id
to_brand_id
payment_total
created_by
created_date
updated_by
updated_date


is_bulk
UID
DepositTo
AccountUID
CustomerUID
URI
myob_array
RowVersion
myob_id

  */


}
